module.exports = __webpack_public_path__ + "img/count.66edb112.jpg";